import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getCases } from '@/lib/api';
import { motion } from 'framer-motion';
import { fadeUp, stagger } from '@/lib/motion';
import { PageHero, Section } from '@/components/shared/Section';
import { ShieldCheck, ArrowRight, MessageCircle, Quote } from 'lucide-react';

export default function CasesHub() {
  const [cases, setCases] = useState([]);
  useEffect(() => { getCases().then(r => setCases(r.data)).catch(() => {}); }, []);

  return (
    <div>
      <PageHero badge="CASOS DE ÉXITO" badgeIcon={ShieldCheck} h1="Resultados que hablan" subtitle="Proyectos reales con métricas verificables. Conoce cómo ALLCOM ha transformado operaciones en Chile."
        primaryCTA={<Link to="/contacto" className="inline-flex items-center justify-center gap-2 px-6 py-3.5 text-sm font-semibold text-white bg-[#0EA5E9] rounded-xl hover:bg-sky-600 shadow-lg">Agendar demo <ArrowRight className="w-4 h-4" /></Link>}
        secondaryCTA={<a href="https://wa.me/56975294340" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 px-6 py-3.5 text-sm font-semibold text-emerald-400 border border-emerald-400/30 rounded-xl hover:bg-emerald-400/10"><MessageCircle className="w-4 h-4" /> WhatsApp</a>}
      />
      <Section>
        <motion.div variants={stagger} className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {cases.map((c) => (
            <motion.div key={c.slug} variants={fadeUp}>
              <Link to={`/casos/${c.slug}`} className="p-6 sm:p-8 rounded-2xl bg-white border border-slate-200 shadow-[0_10px_30px_rgba(2,6,23,0.08)] card-hover h-full flex flex-col group">
                <span className="text-xs font-semibold uppercase tracking-wider text-[#0EA5E9] mb-3">{c.industry}</span>
                <h3 className="text-lg font-semibold mb-3" style={{fontFamily:'Syne,sans-serif'}}>{c.title}</h3>
                <p className="text-sm text-[#64748B] mb-4">{c.summary}</p>
                {c.problem && <div className="mb-3"><span className="text-xs font-semibold text-slate-500">Problema:</span><p className="text-sm text-slate-600 mt-1">{c.problem}</p></div>}
                {c.solution && <div className="mb-4"><span className="text-xs font-semibold text-slate-500">Solución:</span><p className="text-sm text-slate-600 mt-1">{c.solution}</p></div>}
                {c.metrics && (
                  <div className="grid grid-cols-3 gap-2 mb-4">
                    {c.metrics.map((m, i) => (
                      <div key={i} className="text-center p-2 rounded-lg bg-slate-50">
                        <div className="text-sm font-bold text-[#0A2540]">{m.value}</div>
                        <div className="text-[10px] text-[#64748B]">{m.label}</div>
                      </div>
                    ))}
                  </div>
                )}
                {c.quote && (
                  <div className="flex items-start gap-2 p-3 bg-slate-50 rounded-xl mt-auto">
                    <Quote className="w-4 h-4 text-[#0EA5E9] shrink-0 mt-0.5" />
                    <p className="text-xs text-slate-600 italic leading-relaxed">{c.quote}</p>
                  </div>
                )}
                <span className="inline-flex items-center gap-1 text-xs font-medium text-[#0EA5E9] mt-3 opacity-0 group-hover:opacity-100 transition-opacity">Ver caso completo <ArrowRight className="w-3.5 h-3.5" /></span>
              </Link>
            </motion.div>
          ))}
        </motion.div>
      </Section>
    </div>
  );
}
